import React from "react";
import style from "./application-status.scss";
import { StatusItem } from "./status-item/status-item";
import {
  ESTIMATE_STATUSES,
  OUTCOME_STATUSES,
  OutcomeType,
  OutcomeTypes,
  StatusDetail,
  StatusType,
  StatusTypes,
} from "../../your-applications.consts";
import {
  applicationStatusMapV2,
  applicationStatusMapV1,
} from "./application-status.const";

export const renderStatusContainer = (statuses: (StatusDetail | null)[]) => {
  return (
    <div className="status-container">
      <style jsx>{style}</style>
      {statuses.map((detail, idx) => (
        <StatusItem
          key={idx}
          status={detail?.status}
          message={detail?.message}
          outcome={detail?.outcome}
        />
      ))}
    </div>
  );
};

export const getStatusIcon = (status: StatusType) => {
  switch (status) {
    case StatusTypes.PENDING:
      return "action-sync";
    case StatusTypes.ACTION:
      return "status-warning";
    case StatusTypes.COMPLETE:
      return "status-success";
    case StatusTypes.ERROR:
      return "status-error";
    case StatusTypes.INFO:
      return "status-info";
    default:
      return "status-pending-outline";
  }
};

export const getBadgeStyle = (outcome: OutcomeType) => {
  switch (outcome) {
    case OutcomeTypes.SETTLED:
      return "success";
    case OutcomeTypes.DECLINED:
      return "critical";
    default:
      return "neutral";
  }
};

export const getApplicationStatus = (
  loanStatus: string | null,
  detailedLoanStatus: string | null,
  loanStatusWorkflowUpgradePhase2 = false,
  brokerPortalWorkflowStatusChangesEnabled = false
) => {
  const status =
    OUTCOME_STATUSES.has(loanStatus ?? "") ||
    ESTIMATE_STATUSES.has(loanStatus ?? "") ||
    !brokerPortalWorkflowStatusChangesEnabled
      ? loanStatus
      : detailedLoanStatus;

  if (!status) return null;

  if (!loanStatusWorkflowUpgradePhase2) {
    return applicationStatusMapV1[status] ?? null;
  }
  return applicationStatusMapV2[status] ?? null;
};
